import { render } from "./DefaultSetupPopUp.vue?vue&type=template&id=2121ee54&scoped=true"
import script from "./DefaultSetupPopUp.js?vue&type=script&lang=js"
export * from "./DefaultSetupPopUp.js?vue&type=script&lang=js"

import "./DefaultSetupPopUp.vue?vue&type=style&index=0&id=2121ee54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2121ee54"]])

export default __exports__